// extracted by mini-css-extract-plugin
module.exports = {"container":"TransactionDeclaring_container_2mMOM","status":"TransactionDeclaring_status_2jxoL","content":"TransactionDeclaring_content_3K1Ly"};